module.exports = __webpack_public_path__ + "fonts/almoni-black-aaa.35631fb.woff2";